import { Field } from '@headlessui/react';
import { FC } from 'react';
import { useForm } from 'react-hook-form';
import { Label } from '@/components/form/label';
import { TextInput } from '@/components/form/text-input';
import { Button } from '@/components/ui/button';
import { useCurrentOrganisation } from '@/hooks/use-current-organisation';
import { api } from '@/redux/api';

export type CreateContactFormProps = {
  addressBookId: string;
  contactFormType?: 'primaryContact';
  contactId?: string;
};
interface formInput {
  contactName: string;
  phoneNumber: string;
}

export const CreateContactForm: FC<CreateContactFormProps> = ({
  addressBookId,
  contactFormType,
  contactId,
}) => {
  const [createAddressBookContact] = api.useCreateAddressBookContactMutation();
  const [updateAddressBookContact] = api.useUpdateAddressBookContactMutation();
  const { register, handleSubmit } = useForm<formInput>();
  const { organisation } = useCurrentOrganisation();

  if (contactFormType && contactFormType === 'primaryContact') {
    const onSubmit = (data: formInput) =>
      updateAddressBookContact({
        addressBookId: addressBookId,
        contact: { name: data.contactName, providerContact: '22222222' },
        contactId: contactId ?? '',
        actionType: 'updateAddressBookContact',
        organisationId: organisation?.id ?? 0,
      });
    return (
      <div>
        <form className={'grid gap-4'} onSubmit={handleSubmit(onSubmit)}>
          <Field className="mt-6 flex min-h-12 flex-col items-start justify-between gap-2">
            <Label>Contact Name:</Label>
            <TextInput
              className={'outline-1 outline-solid'}
              {...register('contactName')}
            ></TextInput>
          </Field>
          <Button className="place-self-start" type="submit">
            Update Contact
          </Button>
        </form>
      </div>
    );
  } else {
    const onSubmit = (data: formInput) =>
      createAddressBookContact({
        addressBookId: addressBookId,
        contact: { name: data.contactName, phoneNumber: data.phoneNumber },
        actionType: 'createAddressBookContact',
        organisationId: organisation?.id ?? 0,
      });

    return (
      <div>
        <form
          className={'grid-rows grid gap-4'}
          onSubmit={handleSubmit(onSubmit)}
        >
          <div className="grid-col grid-cols-2">
            <Field className="mt-6 flex min-h-12 flex-col items-start justify-between gap-2">
              <Label>Contact Name:</Label>
              <TextInput
                className={'outline-1 outline-solid'}
                {...register('contactName')}
              ></TextInput>
            </Field>
            <Field className="mt-6 flex min-h-12 flex-col items-start justify-between gap-2">
              <Label>Phone Number:</Label>
              <TextInput
                className={'outline-1 outline-solid'}
                {...register('phoneNumber')}
              ></TextInput>
            </Field>
          </div>
          <Button className="place-self-start" type="submit">
            Add Contact
          </Button>
        </form>
      </div>
    );
  }
};
